exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*************** styling of import starts  ********************/\r\n\r\n/*********** hide input textbox and look like button - starts ***********/\r\ninput[type=\"file\"] {\r\n    display:none;\r\n}\r\n\r\n.upload_label{\r\n    display: -ms-inline-flexbox;\r\n    display: inline-flex;\r\n    -ms-flex-align: center;\r\n        align-items: center;\r\n    cursor: pointer;\r\n    margin-bottom: 0;\r\n}\r\n\r\n.btn-import {\r\n    vertical-align: middle;\r\n    width: auto;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n    margin-left: 5px;\r\n    margin-right: 5px;\r\n    font-size: 13px;\r\n    font-weight: normal;\r\n}\r\n/***********hide input textbox and look like button - ends***********/\r\n\r\n/*********** import icon styling  ***********/\r\n.image-import {\r\n    width: 20px;\r\n    height: 20px;\r\n}\r\n\r\n/*************** styling of import ends  ********************/", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/shared/components/import/import.component.css
// module id = ../../../../../src/app/shared/components/import/import.component.css
// module chunks = main